export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  categories: string[];
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
  { slug: 'workplace', name: '职场', icon: 'ri-briefcase-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '社内恋爱',
    author: '金智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20romance%20cover%20art%20office%20romance%20elegant%20couple%20soft%20warm%20lighting%20illustration%20style%20clean%20background%20manga%20aesthetic&width=400&height=560&seq=hanman-cover-01&orientation=portrait',
    categories: ['romance', 'workplace'],
    description: '在首尔最顶尖的广告公司，两个竞争对手被迫合作一个重大项目。她冷静理性，他热情奔放，办公室里的每一次交锋都暗藏心动。当商业合作变成情感博弈，谁会成为最后的赢家？',
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch1-1', title: '第1话 命运的交汇', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch1-2', title: '第2话 竞争对手', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch1-3', title: '第3话 意外合作', number: 3, updatedAt: '2026-06-15' },
      { id: 'ch1-4', title: '第4话 深夜加班', number: 4, updatedAt: '2026-06-22' },
      { id: 'ch1-5', title: '第5话 心跳瞬间', number: 5, updatedAt: '2026-06-29' },
      { id: 'ch1-6', title: '第6话 暧昧信号', number: 6, updatedAt: '2026-07-06' },
      { id: 'ch1-7', title: '第7话 告白之夜', number: 7, updatedAt: '2026-07-13' },
      { id: 'ch1-8', title: '第8话 甜蜜升温', number: 8, updatedAt: '2026-07-20' },
    ],
  },
  {
    id: 'comic-2',
    title: '魔王大人的契约新娘',
    author: '李恩在',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20cover%20art%20demon%20king%20and%20bride%20gothic%20elegant%20dark%20red%20accents%20illustration%20style%20clean%20composition&width=400&height=560&seq=hanman-cover-02&orientation=portrait',
    categories: ['fantasy', 'romance'],
    description: '平凡大学生林小夏意外被召唤到异世界，成为魔王的新娘？这场荒唐的契约婚姻背后，隐藏着两个世界的命运。当她逐渐发现魔王内心深处的温柔，契约变成了真心。',
    status: '连载中',
    rating: 4.9,
    views: 2380000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: true,
    chapters: [
      { id: 'ch2-1', title: '第1话 异世界召唤', number: 1, updatedAt: '2026-05-15' },
      { id: 'ch2-2', title: '第2话 契约之吻', number: 2, updatedAt: '2026-05-22' },
      { id: 'ch2-3', title: '第3话 魔王的秘密', number: 3, updatedAt: '2026-05-29' },
      { id: 'ch2-4', title: '第4话 城堡日常', number: 4, updatedAt: '2026-06-05' },
      { id: 'ch2-5', title: '第5话 暗流涌动', number: 5, updatedAt: '2026-06-12' },
      { id: 'ch2-6', title: '第6话 真心显露', number: 6, updatedAt: '2026-06-19' },
    ],
  },
  {
    id: 'comic-3',
    title: '猎魔人学院',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20cover%20art%20demon%20hunter%20academy%20swordsman%20dynamic%20pose%20dark%20atmosphere%20blue%20energy%20illustration%20style%20clean%20composition&width=400&height=560&seq=hanman-cover-03&orientation=portrait',
    categories: ['action', 'fantasy'],
    description: '隐藏在首尔市中心的猎魔人学院，培养着对抗黑暗势力的新一代战士。主角金宇镇从一个普通高中生，成长为最年轻的S级猎魔人。热血、友情、战斗，青春在刀光剑影中燃烧！',
    status: '连载中',
    rating: 4.7,
    views: 1890000,
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch3-1', title: '第1话 觉醒之日', number: 1, updatedAt: '2026-04-10' },
      { id: 'ch3-2', title: '第2话 入学考试', number: 2, updatedAt: '2026-04-17' },
      { id: 'ch3-3', title: '第3话 第一个任务', number: 3, updatedAt: '2026-04-24' },
      { id: 'ch3-4', title: '第4话 黑暗降临', number: 4, updatedAt: '2026-05-01' },
    ],
  },
  {
    id: 'comic-4',
    title: '隔壁的猫系少女',
    author: '崔秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20romance%20cover%20art%20cute%20girl%20with%20cat%20ears%20neighbor%20story%20warm%20pastel%20colors%20illustration%20style%20clean%20cozy%20atmosphere&width=400&height=560&seq=hanman-cover-04&orientation=portrait',
    categories: ['comedy', 'romance', 'daily'],
    description: '搬到新公寓的程序员李俊昊，发现隔壁住着一个行为像猫一样的奇怪女孩。她时而傲娇、时而黏人，让他的生活彻底失控。一段治愈又搞笑的邻里恋爱物语就此展开。',
    status: '连载中',
    rating: 4.6,
    views: 980000,
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch4-1', title: '第1话 奇怪的新邻居', number: 1, updatedAt: '2026-07-01' },
      { id: 'ch4-2', title: '第2话 猫咪习性', number: 2, updatedAt: '2026-07-08' },
      { id: 'ch4-3', title: '第3话 投喂日常', number: 3, updatedAt: '2026-07-15' },
    ],
  },
  {
    id: 'comic-5',
    title: '末日生存法则',
    author: '姜泰浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20apocalypse%20thriller%20cover%20art%20survival%20dystopian%20city%20ruins%20dark%20moody%20atmosphere%20protagonist%20with%20weapon%20illustration%20style&width=400&height=560&seq=hanman-cover-05&orientation=portrait',
    categories: ['action', 'thriller'],
    description: '一场突如其来的病毒席卷全球，感染者变成嗜血怪物。普通上班族韩泰成必须在末日废墟中挣扎求生。当文明崩塌，人性成为最危险的武器。',
    status: '连载中',
    rating: 4.5,
    views: 1560000,
    updatedAt: '2026-07-30',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch5-1', title: '第1话 零号病人', number: 1, updatedAt: '2026-03-20' },
      { id: 'ch5-2', title: '第2话 逃离首尔', number: 2, updatedAt: '2026-03-27' },
      { id: 'ch5-3', title: '第3话 幸存者营地', number: 3, updatedAt: '2026-04-03' },
    ],
  },
  {
    id: 'comic-6',
    title: '我的ID是江南美人',
    author: '郑多恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20drama%20cover%20art%20beautiful%20girl%20university%20campus%20transformation%20story%20soft%20lighting%20elegant%20illustration%20style&width=400&height=560&seq=hanman-cover-06&orientation=portrait',
    categories: ['drama', 'school', 'romance'],
    description: '因为外貌自卑的姜美来，在大学入学前做了整容手术。她以为新面貌能带来新生活，却卷入了关于美与真实的漩涡。当校园里的目光都聚焦在她身上，真正的自我在哪里？',
    status: '已完结',
    rating: 4.9,
    views: 3200000,
    updatedAt: '2026-07-15',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch6-1', title: '第1话 新的开始', number: 1, updatedAt: '2026-01-10' },
      { id: 'ch6-2', title: '第2话 校园初见', number: 2, updatedAt: '2026-01-17' },
      { id: 'ch6-3', title: '第3话 谣言四起', number: 3, updatedAt: '2026-01-24' },
      { id: 'ch6-4', title: '第4话 真心告白', number: 4, updatedAt: '2026-01-31' },
      { id: 'ch6-5', title: '第5话 最终回 真实的她', number: 5, updatedAt: '2026-02-07' },
    ],
  },
  {
    id: 'comic-7',
    title: '九尾狐传',
    author: '尹贤宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20mythology%20cover%20art%20nine%20tailed%20fox%20gumiho%20ancient%20korean%20aesthetic%20mystical%20atmosphere%20elegant%20illustration%20style&width=400&height=560&seq=hanman-cover-07&orientation=portrait',
    categories: ['fantasy', 'drama', 'romance'],
    description: '活了千年的九尾狐李砚，在现代首尔寻找转世的爱人。每一次轮回，他都守护在她身边，却不能相认。当古老的诅咒与都市的新生活碰撞，这段跨越千年的爱情能否开花结果？',
    status: '连载中',
    rating: 4.8,
    views: 2100000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch7-1', title: '第1话 千年之约', number: 1, updatedAt: '2026-04-05' },
      { id: 'ch7-2', title: '第2话 现代相遇', number: 2, updatedAt: '2026-04-12' },
      { id: 'ch7-3', title: '第3话 前世记忆', number: 3, updatedAt: '2026-04-19' },
    ],
  },
  {
    id: 'comic-8',
    title: '职场生存报告',
    author: '宋敏浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20office%20comedy%20cover%20art%20corporate%20life%20young%20employee%20humorous%20expression%20modern%20office%20setting%20illustration%20style%20clean&width=400&height=560&seq=hanman-cover-08&orientation=portrait',
    categories: ['comedy', 'workplace', 'drama'],
    description: '新入职大企业的金代理，每天都在上司的无理要求和同事的明争暗斗中艰难求生。真实到令人窒息的职场生态，笑中带泪的打工人日常！每个上班族都能找到自己的影子。',
    status: '连载中',
    rating: 4.4,
    views: 870000,
    updatedAt: '2026-07-28',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch8-1', title: '第1话 入职第一天', number: 1, updatedAt: '2026-05-20' },
      { id: 'ch8-2', title: '第2话 加班地狱', number: 2, updatedAt: '2026-05-27' },
    ],
  },
  {
    id: 'comic-9',
    title: '花店老板的秘密',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20romance%20cover%20art%20flower%20shop%20owner%20secrets%20moody%20lighting%20suspense%20elegant%20woman%20illustration%20style%20beautiful%20flowers&width=400&height=560&seq=hanman-cover-09&orientation=portrait',
    categories: ['thriller', 'romance', 'drama'],
    description: '江南小巷深处有一家神秘的花店，店主是一位美丽而寡言的女子。每一位收到她花束的人，都会发生奇妙的变化。当调查记者走近真相，才发现这家花店背后隐藏着惊人的秘密。',
    status: '连载中',
    rating: 4.7,
    views: 1340000,
    updatedAt: '2026-07-31',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch9-1', title: '第1话 小巷花店', number: 1, updatedAt: '2026-06-10' },
      { id: 'ch9-2', title: '第2话 神秘花束', number: 2, updatedAt: '2026-06-17' },
    ],
  },
  {
    id: 'comic-10',
    title: '我们学校的F4',
    author: '权恩彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20cover%20art%20four%20handsome%20boys%20elite%20high%20school%20uniforms%20bright%20youthful%20aesthetic%20illustration%20style%20clean&width=400&height=560&seq=hanman-cover-10&orientation=portrait',
    categories: ['school', 'romance', 'comedy'],
    description: '转学到精英高中的普通女孩，意外闯入了由四位风云人物组成的F4世界。傲娇的会长、温柔的音乐天才、冷酷的运动健将、神秘的艺术少年——谁说校园恋爱只有一个选择？',
    status: '已完结',
    rating: 4.5,
    views: 1750000,
    updatedAt: '2026-06-20',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch10-1', title: '第1话 转学生', number: 1, updatedAt: '2026-02-15' },
      { id: 'ch10-2', title: '第2话 F4登场', number: 2, updatedAt: '2026-02-22' },
      { id: 'ch10-3', title: '第3话 图书馆偶遇', number: 3, updatedAt: '2026-03-01' },
    ],
  },
  {
    id: 'comic-11',
    title: '剑与魔法的国度',
    author: '权志龙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20adventure%20cover%20art%20sword%20and%20magic%20epic%20quest%20medieval%20fantasy%20world%20hero%20illustration%20style%20dynamic&width=400&height=560&seq=hanman-cover-11&orientation=portrait',
    categories: ['fantasy', 'action'],
    description: '从一个无名村庄走出的少年艾伦，手握传说中的圣剑，踏上了拯救王国的旅程。魔法师、精灵、龙族——奇幻世界的宏伟画卷徐徐展开，一场史诗级的冒险即将启程！',
    status: '连载中',
    rating: 4.6,
    views: 1100000,
    updatedAt: '2026-07-29',
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch11-1', title: '第1话 预言中的少年', number: 1, updatedAt: '2026-04-20' },
      { id: 'ch11-2', title: '第2话 圣剑觉醒', number: 2, updatedAt: '2026-04-27' },
    ],
  },
  {
    id: 'comic-12',
    title: '美食家罗曼史',
    author: '张美娜',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20food%20romance%20cover%20art%20chef%20couple%20cooking%20delicious%20dishes%20warm%20kitchen%20atmosphere%20illustration%20style%20cozy&width=400&height=560&seq=hanman-cover-12&orientation=portrait',
    categories: ['romance', 'daily', 'comedy'],
    description: '美食评论家与天才厨师之间的甜蜜对决！她挑剔的味蕾遇上他自信的厨艺，从互相嫌弃到不可自拔。每一话都让人食指大动，每一页都甜到发腻。让人欲罢不能的美食恋爱喜剧！',
    status: '连载中',
    rating: 4.3,
    views: 760000,
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch12-1', title: '第1话 差评如潮', number: 1, updatedAt: '2026-07-01' },
      { id: 'ch12-2', title: '第2话 厨房对决', number: 2, updatedAt: '2026-07-08' },
    ],
  },
];

export const hotComics = comics.filter((c) => c.isHot);
export const newComics = comics.filter((c) => c.isNew);

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categories.includes(slug));
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}